module.exports = __webpack_public_path__ + "media/application/images/footer-arrow-sm-708c35f7b6de6926c65cd33c32e21810.svg";